<form [formGroup]="configurationFormFile">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.general.file-format' |
        translate}}</label>
      <ejs-dropdownlist [dataSource]="fileFormats" [fields]="enumDropdownSettings" id="ic-fileFormat"
        formControlName="fileFormat">
        <ng-template #itemTemplate let-data>
          {{data.text | translate}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{data.text | translate}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormFile.controls.fileFormat"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-fileNameSearchPattern" class="control-label">{{
        'i18n.domain.import-configuration.edit.file.general.file-name-search-criteria' | translate }}</label>
      <input id="ic-fileNameSearchPattern" type="text" class="form-control" formControlName="fileNameSearchPattern" />
      <app-error-messages [control]="configurationFormFile.controls.fileNameSearchPattern"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label class="control-label">{{'i18n.domain.import-configuration.edit.general.navision-template' |
        translate}}</label>
      <app-enum-drop-down-list formControlName="navisionImportTemplate" [showClearButton]="false"
        [enumType]="NavisionImportTemplate"
        baseTranslationString='i18n.domain.import-configuration.enums.navision-import-template.'>
      </app-enum-drop-down-list>
      <app-error-messages [control]="configurationFormFile.controls.navisionImportTemplate"></app-error-messages>
    </div>
  </div>
  @if(configurationFormFile.controls.fileFormat.value === ImportFileFormat.PDF && transferType === ImportConfigurationTransferType.Email){
    <div class="form-row row">
      <div class="form-group col-xl-4 col-lg-6">
        <label for="convertEmailContentToPdf" class="control-label">{{
          'i18n.domain.import-configuration.edit.file.general.convert-email-content-to-pdf' | translate }}</label>
        <app-yes-no-group-button id="convertEmailContentToPdf" formControlName="convertEmailContentToPdf"></app-yes-no-group-button>  
        <app-error-messages [control]="configurationFormFile.controls.convertEmailContentToPdf"></app-error-messages>
      </div>
    </div>
  }
  @if(configurationFormFile.controls.fileFormat.value === ImportFileFormat.CSV){
      <div class="form-row row">
      <div class="form-group col-xl-4 col-lg-6">
        <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.general.decimal-seperator' |
          translate}}</label>
        <ejs-dropdownlist [dataSource]="decimalSeperators" [fields]="enumDropdownSettings" id="ic-decimalSeperator"
          formControlName="decimalSeperator">
          <ng-template #itemTemplate let-data>
            {{data.text | translate}}
          </ng-template>
          <ng-template #valueTemplate let-data>
            <div class="centered">
              <span>{{data.text | translate}}</span>
            </div>
          </ng-template>
        </ejs-dropdownlist>
        <app-error-messages [control]="configurationFormFile.controls.decimalSeperator"></app-error-messages>
      </div>
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-seperatorCharacter" class="control-label"
          [ngClass]="{'required': configurationFormFile.controls.fileFormat.value === ImportFileFormat.CSV }">{{
          'i18n.domain.import-configuration.edit.file.general.seperator' | translate }}</label>
        <input id="ic-seperatorCharacter" type="text" class="form-control" formControlName="seperatorCharacter" />
        <app-error-messages [control]="configurationFormFile.controls.seperatorCharacter"></app-error-messages>
      </div>
      <div class="form-group col-xl-4 col-lg-6">
        <label class="control-label required">{{'i18n.domain.import-configuration.edit.file.general.text-format' |
          translate}}</label>
        <app-button-group id="ic-textFormat" [fieldsEnum]="TextFormat" [isNumericEnum]="true" formControlName="textFormat"
          [translateKey]="'i18n.domain.import-configuration.enums.text-format.'">
        </app-button-group>
      </div>
    </div>
  }
  <div class="form-row row">
    @if(configurationFormFile.controls.fileFormat.value === ImportFileFormat.CSV){
      <div class="form-group col-xl-4 col-lg-6">
        <label class="control-label required">{{ 'i18n.domain.import-configuration.edit.file.general.titel-included' |
          translate }}</label>
        <app-yes-no-group-button id="ic-isTitleContainedInFile"
          formControlName="isTitleContainedInFile"></app-yes-no-group-button>
      </div>
    }
    <!-- We will hide this option completely as this is not tested completely -->
    <div class="d-none">
      @if(canSendResponse){
        <div class="form-group col-xl-4 col-lg-6">
          <label class="control-label required">{{ 'i18n.domain.import-configuration.edit.file.general.send-response' |
            translate }}</label>
          <app-yes-no-group-button id="ic-sendResponse" formControlName="sendResponse"></app-yes-no-group-button>
        </div>
      }
    </div>
  </div>
</form>
